import { Service } from '@roc/feature-app-core';

const url = {
  GET_FORM_INFO:
    '/api/v1/loan/borrowerIdentityCheck/getBorrowerIdentityCheckFormInfo',
  UPLOAD_DRIVERS_LICENSE:
    '/api/v1/loan/borrowerIdentityCheck/uploadDriversLicense',
  SAVE_FINANCIAL_INFORMATION:
    '/api/v1/loan/borrowerIdentityCheck/saveFinancialInformation',
  DOWNLOAND_DL_FILE: '/api/v1/loan/borrowerIdentityCheck/downloadDLFile',
  SAVE_ID_INFORMATION: '/api/v1/loan/borrowerIdentityCheck/saveIdInformation',
  CHANGE_FORM_STATUS: '/api/v1/loan/borrowerIdentityCheck/changeFormStatus',
};

export class IdentityCheckService extends Service {
  getBorrowerBorrowerIdentityCheckFormInfo(lenderId, borrowerId) {
    return this.get(`${url.GET_FORM_INFO}`, { lenderId, borrowerId });
  }

  uploadDriversLicense(identityCheckForm, driversLicense: File) {
    const identityCheckJson = new Blob([JSON.stringify(identityCheckForm)], {
      type: 'application/json',
    });

    const formData = new FormData();
    formData.append('identityCheckForm', identityCheckJson);
    formData.append('driversLicense', driversLicense);

    return this.post(url.UPLOAD_DRIVERS_LICENSE, formData);
  }

  saveFinancialInformation(data) {
    return this.post(url.SAVE_FINANCIAL_INFORMATION, data);
  }

  changeFormStatus(data, loanId) {
    return this.post(`${url.CHANGE_FORM_STATUS}?loanId=${loanId}`, data);
  }

  saveIdInformation(data) {
    return this.post(url.SAVE_ID_INFORMATION, data);
  }

  downloadDLFile(borrowerId, lenderId) {
    return this.post(
      `${url.DOWNLOAND_DL_FILE}?borrowerId=${borrowerId}&lenderId=${lenderId}`,
      {},
      null,
      {
        responseType: 'arraybuffer',
      }
    );
  }
}
